<div class="master_uploader">
  <div class="img_uploader">
    <p>Upload Images
      <span class="dimensions">(450 ✕ 500 - Png, Jpg, Jpeg)</span>
    </p>
    <img src="../../../../../../../assets/images/icons/file.svg" alt="">
    <input type="file" class="file_input" #fileVariable multiple (change)="setFiles(fileVariable.files)">
  </div>
  <div class="uploaded_img">
    <ul>
      <ng-container *ngIf="fileInput?.value && type==='IMAGE'">
        <li *ngFor="let singleFile of fileInput?.value; let i = index">
          <img [src]="singleFile.url" alt="" class="preview_img">
          <div class="close_img">
            <img src="../../../../../assets/images/icons/close.svg" alt="" (click)="removeUrl(i)">
          </div>
        </li>
      </ng-container>
      <ng-container *ngIf="fileInput?.value && type==='VIDEO'">
        <li *ngFor="let singleFile of fileInput?.value; let i = index">
          <img [src]="singleFile.url" alt="" class="preview_img">
          <div class="close_img">
            <img src="../../../../../assets/images/icons/close.svg" alt="" (click)="removeUrl(i)">
          </div>
        </li>
      </ng-container>


    </ul>
    <ng-container *ngFor="let singleFile of mediaList;let i = index">
      <app-single-upload [singleFile]="singleFile" (output)="addFile($event)"></app-single-upload>
    </ng-container>
  </div>
</div>
	